import React, { useState, useEffect } from 'react';
import { api } from '../api';
import '../App.css';

const WinnerDisplay = () => {
    const [winner, setWinner] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchWinner = async () => {
            try {
                const data = await api.getWinner();
                if (data.winner) {
                    setWinner(data.winner);
                }
            } catch (error) {
                console.error('Failed to fetch winner:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchWinner();
    }, []);

    if (loading) return <div className="winner-display neon-box"><h3>👑 Dünün Kazananı</h3><p>Yükleniyor...</p></div>;

    if (!winner) return (
        <div className="winner-display neon-box">
            <h3>👑 Dünün Kazananı</h3>
            <p>Henüz kazanan yok.</p>
        </div>
    );

    return (
        <div className="winner-display neon-box">
            <h3>👑 Dünün Kazananı</h3>
            <div className="winner-info">
                <div className="winner-name">{winner.display_name}</div>
                <div className="winner-score">{winner.score} Puan</div>
                <div className="winner-city">📍 {winner.city_name}</div>
            </div>
        </div>
    );
};

export default WinnerDisplay;
